import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import { getRGBA } from 'utils/color'

interface ChipStatusProps {
  text: string
  messages?: Messages
}

interface Messages {
  failed: string
  success: string
  processing: string
  waiting: string
}

const styles = makeStyles(() => ({
  chip: {
    padding: '0.25rem 0.75rem',
    borderRadius: '0.75rem',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    width: 'fit-content',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },

  chipFailed: {
    color: '#BA1A1A !important',
    backgroundColor: `${getRGBA('#BA1A1A', 0.08)} !important`,
  },

  chipSuccess: {
    color: '#2E7D32 !important',
    backgroundColor: `${getRGBA('#2E7D32', 0.08)} !important`,
    opacity: 1,
  },

  chipUnauthorized: {
    color: '#EF6C00 !important',
    backgroundColor: `${getRGBA('#EF6C00', 0.08)} !important`,
    opacity: 1,
  },

  chipProcessing: {
    color: '#3024E1',
    backgroundColor: '#EAE9FC',
  },

  chipWaiting: {
    color: '#191C1A !important',
    backgroundColor: `${getRGBA('#BDBDBD', 0.4)} !important`,
    display: 'flex',
    alignItems: 'center',
    opacity: 0.38,
  },
}))

const ChipStatus: React.FC<ChipStatusProps> = ({
  text,
  messages = {
    failed: 'Erro no Processamento',
    success: 'Finalizado',
    processing: 'Processando',
    waiting: 'Em Espera',
  },
}) => {
  const successTextList = ['Finalizado', 'success', 'granted', 'authorized']
  const pendingTextList = ['Pendente', 'Processando', 'running', 'queued', 'scheduled']
  const failedTextList = ['failed', 'Falhou']
  const blockTextList = ['block']

  const classes = styles()

  let actualClass = null
  let actualMessage = null
  let chipClass = classes.chip

  if (failedTextList.includes(text) || blockTextList.includes(text)) {
    actualClass = classes.chipFailed
    actualMessage = messages.failed
  } else if (pendingTextList.includes(text)) {
    actualClass = classes.chipProcessing
    actualMessage = messages.processing
  } else if (successTextList.includes(text)) {
    actualClass = classes.chipSuccess
    actualMessage = messages.success
  } else {
    actualClass = classes.chipWaiting
    actualMessage = messages.waiting
  }

  if (text == '') {
    actualClass = ''
    chipClass = ''
    actualMessage = '-'
  }

  return <span className={clsx(chipClass, actualClass)}>{actualMessage}</span>
}

export default ChipStatus
